import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { customInstance } from "@/lib/axios";

/**
 * Org application link: /apply/org/:slug (e.g. /apply/org/shmucore).
 * Fetches GET /api/intake/org/:slug/ (creates app+invite), then redirects to the returned invite_url.
 */
export function OrgLinkRedirectPage() {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const { data, error, isSuccess } = useQuery({
    queryKey: ["org-link", token],
    queryFn: async () => {
      const { data: res } = await customInstance.get<{ invite_url: string }>(
        `/api/intake/org/${token}/`
      );
      return res;
    },
    enabled: !!token,
    retry: false,
  });

  useEffect(() => {
    if (isSuccess && data?.invite_url) {
      window.location.href = data.invite_url;
      return;
    }
  }, [isSuccess, data]);

  if (error) {
    const message =
      (error as any)?.response?.data?.error === "Organization is not active"
        ? "This dealer is not yet accepting applications. Please try again later or contact the dealer."
        : "Invalid or expired link.";
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
        <div className="text-center">
          <p className="text-red-600 font-medium">{message}</p>
          <button
            type="button"
            onClick={() => navigate("/error")}
            className="mt-4 text-blue-600 underline"
          >
            Go to error page
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <p className="text-gray-600">Redirecting to application…</p>
    </div>
  );
}
